import { Business as API } from '@src/api/types';
import { Business as Data } from '@src/types';

import generateMedia from './media';

const Factory = (api: API): Data => ({
  id: api?.id,
  name: api.localName,
  cover: api.topMedia ? generateMedia(api.topMedia) : undefined,
  address: api?.address,
});

export default Factory;
